// volto-slate/blocks/Table/useTopScrollMirror.js
import { useEffect, useRef } from 'react';

/**
 * Cria e sincroniza uma scrollbar espelho no topo do container,
 * permitindo rolagem horizontal tanto por cima quanto por baixo da tabela.
 */
const useTopScrollMirror = () => {
  const containerRef = useRef(null);
  const mirrorRef = useRef(null);
  const mirrorContentRef = useRef(null);

  useEffect(() => {
    const innerContainer = containerRef.current;
    const mirror = mirrorRef.current;
    const mirrorContent = mirrorContentRef.current;
    if (!innerContainer || !mirror || !mirrorContent) return;

    const table = innerContainer.querySelector('table');
    if (!table) return;

    const syncWidth = () => {
      mirrorContent.style.width = `${table.scrollWidth}px`;
    };
    syncWidth();

    let lock = false;

    const onMirrorScroll = () => {
      if (lock) return;
      lock = true;
      innerContainer.scrollLeft = mirror.scrollLeft;
      lock = false;
    };

    const onContainerScroll = () => {
      if (lock) return;
      lock = true;
      mirror.scrollLeft = innerContainer.scrollLeft;
      lock = false;
    };

    mirror.addEventListener('scroll', onMirrorScroll);
    innerContainer.addEventListener('scroll', onContainerScroll);

    const resizeObserver = new ResizeObserver(syncWidth);
    resizeObserver.observe(table);

    return () => {
      mirror.removeEventListener('scroll', onMirrorScroll);
      innerContainer.removeEventListener('scroll', onContainerScroll);
      resizeObserver.disconnect();
    };
  }, []);

  return { containerRef, mirrorRef, mirrorContentRef };
};

export default useTopScrollMirror;
